

export default {
  metaInfo() {
    return {
      title: this.getPageTitle()
    }
  },
}
